<template>
  <span>{{ money }}</span>
</template>

<script>
import Vue from "vue";
import { formatM } from "@/lib/utils/accountingJsFns";

export default Vue.extend({
  name: "MoneyTotalComponent",
  computed: {
    money() {
      return formatM(this.params.data.Total);
    },
  },
});
</script>

<style scoped></style>
